import React from 'react'
import SchedulesHomeNavigation from './SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../UIElements/SearchByLeagueOrVenue'
import FullSchedule from '../../schedule/FullSchedule'
import Banner from './Banner'

const SchedulesHome = () => {
	return (
		<div style={{ overflowX: 'hidden' }}>
			<SchedulesHomeNavigation />
			<Banner />
			<SearchByLeagueOrVenue />
			<FullSchedule />
		</div>
	)
}

export default SchedulesHome
